// 折线图
<template>
  <div :id="idName"></div>
</template>

<script>
import { Chart } from '@antv/g2';
export default {
  name: 'linechart',
  props: {
    idName: String,
    chartData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData(val) {
      this.render(val);
    }
  },
  mounted() {
    this.chart = new Chart({
      container: this.idName,
      autoFit: true,
      padding: [20, 40, 60, 80]
    });
    this.render(this.chartData);
  },
  methods: {
    render(data) {
      let chart = this.chart;
      chart.data(data);
      chart.scale({
        num: {
          nice: true
        }
      });

      chart.tooltip({
        showCrosshairs: true,
        shared: true
      });

      chart.axis('num', {
        label: {
          formatter: val => {
            return val;
          }
        }
      });

      chart
        .line()
        .position('date*num')
        .color('key')
        .shape('smooth');

      chart
        .point()
        .position('date*num')
        .color('key')
        .shape('circle');

      chart.render();
    }
  }
};
</script>

<style></style>
